import React from 'react';
import styles from './BlueLayout.module.css';
import { G2BadgeTop50, GoHighLevelIcon, MetaBadge } from '@mm/icons';
import { ReactComponent as AudiencesIcon } from 'assets/audiences-icon.svg';
import { ReactComponent as RevenueIcon } from 'assets/revenue-icon.svg';
import { ReactComponent as AutomationIcon } from 'assets/automation.svg';
import { Iconiq } from './Iconiq';
import { Inc500 } from './Inc500';
import { ProductWeek } from './ProductWeek';
import { ProductDay } from './ProductDay';
import { ProductHunt } from './ProductHunt';
import classNames from 'classnames';

type Props = {
  css?: { container?: string };
};

export const HighLevelSignupLayout = ({ css }: Props) => (
  <div
    className={classNames(
      styles.headlineContainer,
      styles.signUpHeadlineContainer,
      styles.highLevelContainer,
      css?.container,
    )}
  >
    <GoHighLevelIcon className={styles.highLevelIcon} />
    <div className={styles.headline}>
      <span>
        Level up your client campaign performance with Customers.ai and
        HighLevel
      </span>
    </div>

    <ul className={styles.list}>
      <li className={classNames(styles.listElement, styles.alignCenter)}>
        <figure>
          <RevenueIcon />
        </figure>
        <span>Identify & resell 5x more contacts</span>
      </li>

      <li className={classNames(styles.listElement, styles.alignCenter)}>
        <figure>
          <AudiencesIcon style={{ width: 24, height: 24 }} />
        </figure>
        <span>White label contacts directly into HighLevel</span>
      </li>

      <li className={classNames(styles.listElement, styles.alignCenter)}>
        <figure>
          <AutomationIcon />
        </figure>
        <span>Amplify HighLevel automations</span>
      </li>
    </ul>

    <div className={styles.rows}>
      <div className={styles.row}>
        <G2BadgeTop50 />
        <Iconiq />
        <MetaBadge className={styles.badge} />
        <Inc500 />
      </div>
      <div className={styles.row}>
        <ProductDay />
        <ProductWeek />
        <ProductHunt />
      </div>
    </div>
  </div>
);
